// SCR-013's routes (NAV-009 reconciliation), composed into the route table by TASK-140. The index
// route is the nav's own parameter-free node (`navEntries`, router/router.ts): reconciliation is
// always read for one org, so it is the same org picker `/reconciliation/:orgId` itself offers.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { RECONCILIATION_INDEX_PATH, RECONCILIATION_ORG_PATH } from "./model";
import { Reconciliation, ReconciliationIndex } from "./reconciliation";

export const routes: ScreenRoute[] = [
  defineRoute({
    nav: "NAV-009",
    path: RECONCILIATION_INDEX_PATH,
    title: "Reconciliation",
    permission: "billing:read",
    component: ReconciliationIndex,
  }),
  defineRoute({
    nav: "NAV-009",
    path: RECONCILIATION_ORG_PATH,
    title: "Reconciliation",
    permission: "billing:read",
    component: Reconciliation,
  }),
];
